<template>
    <div class="table-content">
        <div class="table">
            <el-table :ref="tag" :key="tag" v-loading="tableIsLoading" :data="tableList" height="100%" max-height="100%" :show-summary="true" :summary-method="getSummaries" border @sort-change="sortChange" @row-dblclick="jumpDetails">
                <el-table-column type="index" align="center" width="40" fixed>
                    <template slot="header">
                        <el-tooltip slot="reference" class="item" effect="dark" content="设置隐藏列(点击显示/隐藏)" placement="top">
                            <el-button icon="el-icon-s-tools" type="text" @click="getCustomColumns"></el-button>
                        </el-tooltip>
                    </template>
                </el-table-column>
                <el-table-column label="单据日期" width="110" prop="billDate" :index="1" key="billDate"></el-table-column>
                <el-table-column label="单据类型" width="80" prop="billTypeName" :index="2" key="billTypeName"></el-table-column>
                <el-table-column label="单号" width="190" prop="billNo" :index="3" key="billNo"></el-table-column>
                <el-table-column label="客户" prop="customerName" width="200" :index="6" key="customerName"></el-table-column>
                <el-table-column label="联系人" v-if="customColumnList['boss']" width="110" prop="boss" :index="8" key="boss"></el-table-column>
                <el-table-column label="电话" v-if="customColumnList['phoneNumber']" prop="phoneNumber" width="120" :index="9"  key="phoneNumber"></el-table-column>
                <el-table-column label="地址" v-if="customColumnList['address']" prop="address" min-width="150" :index="10" key="address"></el-table-column>
                <el-table-column label="业务员" width="120" prop="salesmanName" :index="11" key="salesmanName"></el-table-column>
                <el-table-column label="配送员" v-if="customColumnList['deliverUserName']" prop="deliverUserName" width="120" :index="12" key="deliverUserName"></el-table-column>></el-table-column>
                <el-table-column label="仓库" width="140" prop="warehouseName" :index="13" key="warehouseName"></el-table-column>
                <el-table-column label="数量" width="140" prop="qtyFormat" :index="14" key="qtyFormat">
                    <template slot-scope="scope">
                        <div v-if="scope.row.billType == 'FX'">
                            <div v-if="scope.row.visitBillQtyStr.XS">销售:{{ scope.row.visitBillQtyStr.XS.billQtyStr }}</div>
                            <div v-if="scope.row.visitBillQtyStr.XT">退货:{{ scope.row.visitBillQtyStr.XT.billQtyStr }}</div>
                            <div v-if="scope.row.visitBillQtyStr.XH">换货:{{ scope.row.visitBillQtyStr.XH.billQtyStr }}</div>
                        </div>
                        <div v-else>{{scope.row.qtyFormat}}</div>
                    </template>
                </el-table-column>
                <el-table-column label="金额" prop="totalAmt" width="130" :index="15" key="totalAmt"></el-table-column>
                <el-table-column label="欠款金额" v-if="customColumnList['arrearAmt']" width="110" prop="arrearAmt" :index="16"></el-table-column>
                <el-table-column label="剩余未结金额" v-if="customColumnList['arrearbalance']" prop="arrearbalance" width="150" :index="17"></el-table-column>
                <el-table-column label="毛利" v-if="allowCostPrice" width="100" prop="profitAmt" :index="18"></el-table-column>
                <el-table-column label="收款信息" width="150" prop="payConvert" :index="19"></el-table-column>
                <el-table-column label="单据来源" v-if="customColumnList['isFromVehicle']" width="110" prop="isFromVehicle" :index="20"></el-table-column>
                <el-table-column label="制单人" v-if="customColumnList['entryUserName']" width="120" prop="entryUserName" :index="21"></el-table-column>
                <el-table-column label="审核人" v-if="customColumnList['recordedUserName']" width="120" prop="recordedUserName" :index="22"></el-table-column>
                <el-table-column label="审核时间" v-if="customColumnList['recordedDateTime']" width="165" prop="recordedDateTime" :index="23"></el-table-column>
                <!-- 自定义列：按弹窗保存的顺序渲染（支持拖动排序），列宽/列头提示/是否可排序取自 customColumnMeta -->
                <el-table-column v-for="item in sortedCustomColumn" :key="item.prop"
                    :label="item.label" :prop="item.prop"
                    :width="getColumnWidth(item.prop)"
                    :sortable="customColumnMeta[item.prop] && customColumnMeta[item.prop].sortable ? 'custom' : false"
                    :render-header="null">
                    <template slot="header" v-if="customColumnMeta[item.prop] && customColumnMeta[item.prop].tip">
                        <span>{{ item.label }}</span>
                        <el-tooltip effect="light" :content="customColumnMeta[item.prop].tip" placement="top">
                            <i class="iconfont icon-a-bangzhu2" style="color: #ff8940;"></i>
                        </el-tooltip>
                    </template>
                    <template slot-scope="scope" v-if="item.prop == 'qtyFormat'">
                        <div v-if="scope.row.billType == 'FX'">
                            <div v-if="scope.row.visitBillQtyStr.XS">销售:{{ scope.row.visitBillQtyStr.XS.billQtyStr }}</div>
                            <div v-if="scope.row.visitBillQtyStr.XT">退货:{{ scope.row.visitBillQtyStr.XT.billQtyStr }}</div>
                            <div v-if="scope.row.visitBillQtyStr.XH">换货:{{ scope.row.visitBillQtyStr.XH.billQtyStr }}</div>
                        </div>
                        <div v-else>{{scope.row.qtyFormat}}</div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <el-pagination class="pagination" @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="params.page" :page-sizes="[10, 20, 100]" :page-size="params.size" layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
    </div>
</template>
<script>
    import { exportExcelCommonForVue } from '@/assets/js/common.js'
export default {
    props: {
        tag: String,
        arguments: Object,
        tableHeaderList: Array,
        customColumnsList:Array,
        funcCode: Number,
        transmitQuery:Object
    },
    data() {
        return {
            tableIsLoading: false,
            tableList: [],
            summaries: {},
            tableColumnList: [],
            params: this.arguments,
            total: 0,
            // customColumnsList: [{
            //         label: "销售数量",
            //         prop: "saleQty",
            //     },
            //     {
            //         label: "销售金额",
            //         prop: "salTotalAmt",
            //     },
            //     {
            //         label: "退货数量",
            //         prop: "returnQty",
            //     },
            //     {
            //         label: "退货金额",
            //         prop: "returnTotalAmt",
            //     },
            //     {
            //         label: "还货数量",
            //         prop: "backQty",
            //     },
            //     {
            //         label: "还货金额",
            //         prop: "backTotalAmt",
            //     },
            //     {
            //         label: "净销售数量",
            //         prop: "netSaleQty",
            //     },
            //     {
            //         label: "净销售金额",
            //         prop: "netSaleTotalAmt",
            //     },
            //     {
            //         label: "成本金额",
            //         prop: "costPrice",
            //         power: ['allowCostPrice']
            //     },
            //     {
            //         label: "毛利",
            //         prop: "crossProfit",
            //         power: ['allowCostPrice']
            //     },
            //     {
            //         label: "毛利率",
            //         prop: "crossProfitMargin",
            //         power: ['allowCostPrice']
            //     },
            //     {
            //         label: "换货数量",
            //         prop: "exchangeQty",
            //     },
            // ],
            allowCostPrice: false,
            priceArgs: {
                url: "/Account/dataSearchVue/getUserAllowCostPrice.html",
                code: 'isSaleReport'
            },
            customColumn: [],
            isLargessList: [],
            // 自定义列元信息：默认顺序、列宽、是否可排序、表头提示（列头与显隐仍以 customColumn 为准）
            customColumnMeta: {
                sourceBillNo:          { index: 4,  width: 190 },
                reconciliationBillNo:  { index: 5,  width: 200 },
                customerCode:          { index: 7,  width: 100 },
                boss:                  { index: 8,  width: 110 },
                phoneNumber:           { index: 9,  width: 120 },
                address:               { index: 10, width: 150 },
                deliverUserName:       { index: 12, width: 120 },
                qtyFormat:             { index: 14, width: 140 },
                arrearAmt:             { index: 16, width: 110 },
                arrearbalance:         { index: 17, width: 150 },
                profitAmt:             { index: 18, width: 100 },
                isFromVehicle:         { index: 20, width: 110 },
                entryUserName:         { index: 21, width: 120 },
                recordedUserName:      { index: 22, width: 120 },
                recordedDateTime:      { index: 23, width: 165 },
                remark:                { index: 24, width: 130 },
                // 客户/商品维度列表列（需求#154）
                serviceUserName:       { index: 30, width: 130 },
                customerEntryUserName: { index: 31, width: 130 },
                customerLevel:         { index: 32, width: 100 },
                customerLabel:         { index: 33, width: 150 },
                settlementCustomerName:{ index: 34, width: 140 },
                isNewCustomerName:     { index: 35, width: 120 },
                isNewShopName:         { index: 36, width: 120 },
                customerStatus:        { index: 37, width: 100 },
                productLabelName:      { index: 38, width: 130 },
                productClassification: { index: 39, width: 110 },
                isScatterProductName:  { index: 40, width: 110 },
                priceBandLabelName:    { index: 41, width: 110 },
                isMaterialName:        { index: 42, width: 110 },
                countTankStatsName:    { index: 43, width: 130 },
                supplierName:          { index: 44, width: 130 }
            }
        }
    },
    computed: {
        customColumnList() {
            let tempItem = {}
            this.customColumn.forEach(i => {
                tempItem[i.prop] = (i.isShow == 'Y')
            })
            return tempItem
        },
        // 按自定义列配置数组顺序（弹窗拖动后的顺序）渲染；未登记的列排在其后
        sortedCustomColumn() {
            const meta = this.customColumnMeta
            const indexed = this.customColumn
                .map((item, index) => ({ item, index }))
                .filter(row => meta[row.item.prop])
            indexed.sort((a, b) => {
                const sa = typeof a.item.sort === 'number' ? a.item.sort : this.getMetaIndex(a.item.prop)
                const sb = typeof b.item.sort === 'number' ? b.item.sort : this.getMetaIndex(b.item.prop)
                if (sa === sb) return a.index - b.index
                return sa - sb
            })
            return indexed.map(row => row.item)
        }
    },
    watch: {

    },
    created() {
        // this.getCustomColumnsList();
        let unwatch = this.$watch('$store.state.power', (val) => {
            if(val.enterpriseVersion >= 100){
                this.getPriceShow()
            }else {
                this.allowCostPrice = this.$store.state.power.allowCostPrice == 'Y'
            }
            unwatch()
        })
    },
    methods: {
        // 列宽：优先取元信息，未登记的列不设宽（自适应）
        getColumnWidth(prop) {
            const meta = this.customColumnMeta[prop]
            return meta && meta.width ? meta.width : ''
        },
        // 默认顺序：元信息 index；未登记的列排在最后
        getMetaIndex(prop) {
            const meta = this.customColumnMeta[prop]
            return meta && typeof meta.index === 'number' ? meta.index : 999
        },
        // async getTableColumn() {
        //     const { data: res } = await this.$http.post('/Account/saleCollectVue/saleCollectQueryColumn.html', this.Qs.stringify(this.params))
        //     if (res.code != 'success') return false
        //     res.result = JSON.parse(res.result)
        //     console.log(JSON.parse(res.result.data))
        //     this.tableColumnList = JSON.parse(res.result.data)
        // },
        async getPriceShow() {
            const { data: res } = await this.$http.post(this.priceArgs.url, this.Qs.stringify(this.priceArgs))
            this.allowCostPrice = res.result == 'Y'
            console.log(this.allowCostPrice)
        },
        async getTableList() {
            // this.tableList = [
            //     { salesmanID: "82",salesmanName: "13525575787" },
            //     { brandID: "2022103111052600001",brandName: "统一" }
            // ]
            if(!this.params.code){
                return false
            }
            this.tableIsLoading = true
            const { data: res } = await this.$post(this.params.url, this.params)
            this.$message.closeAll()
            if (res.code != '0') {
                this.tableList = []
                this.total = 0
                this.summaries = {}
                this.tableIsLoading = false
                return this.$message.error(res.message)
            }
            let arr = []
            let result = res.data.resultList.map(item => {
                if (item.largessList && item.largessList.length > 0) {
                    item.largessList.forEach(it => {
                        arr.push(it)
                        item[it.prop] = it.value
                    })
                }
                return item
            })
            const newObj = {}
            const newObjArray = []
            arr.forEach((element) => {
                if (!newObj[element.name]) {
                    newObjArray.push({
                        label: element.name,
                        prop: element.prop
                    });
                    newObj[element.name] = true;
                }
            })
            this.isLargessList = newObjArray
            this.tableList = result
            this.total = res.data.total
            this.summaries = res.data.sumData ? res.data.sumData : {}
            this.tableIsLoading = false
        },
        async getCustomColumnsList() {
            // let tempArr = this.customColumnsList.map((item, index) => {
            //     let _id = index + ''
            //     return {
            //         prop: item.prop,
            //         id: _id,
            //         isShow: "Y"
            //     }
            // }).filter(item => (item.prop))
            // console.log(tempArr)
            const { data: res } = await this.$http.post(
                "Account/dataSearchVue/selectColumnByFuncCode.html",
                this.Qs.stringify({ funcCode: this.funcCode })
            );
            if (res.code != "success")
                return this.$confirm(res.message, "提示", {
                    confirmButtonText: "确定",
                    showCancelButton: false,
                    type: "error",
                });
            let result = JSON.parse(res.result);
            let tempArr = [];
            let arr = [];
            this.customColumnsList.some((item) => {
                // if (item.power && !item.power.every((row) => this.$store.state.power[row] == "Y"))
                //     return false;
                if (item.power && !this.allowCostPrice)
                    return false;
                tempArr.push(item);
            });
            tempArr.forEach((item) => {
                // 后端模板已登记的列：按模板 isShow 显示
                let matched = result.find(($item) => item.prop == $item.prop)
                if (matched) {
                    arr.push({
                        id: matched.id,
                        label: item.label,
                        prop: item.prop,
                        isShow: matched.isShow,
                        // 携带用户拖动保存的顺序，供列渲染排序使用（为空表示未拖动过，走默认顺序）
                        sort: typeof matched.sort === 'number' ? matched.sort : null,
                    });
                } else {
                    // 后端模板未登记的新列（需求#154）：加入自定义列配置，默认隐藏，用户勾选后显示
                    arr.push({
                        id: '',
                        label: item.label,
                        prop: item.prop,
                        isShow: 'N',
                    });
                }
            });
            this.customColumn = [...arr]
        },
        getSummaries(param) {
            const { columns } = param
            const sums = [];
            for (let key in this.summaries) {
                columns.forEach((column, index) => {
                    if (index == 1) {
                        sums[index] = '合计'
                        return
                    }
                    if (column.property == key) {
                        sums[index] = this.summaries[key]
                        return
                    }
                })
            }
            this.$nextTick(() => {
                this.$refs[this.tag].doLayout();
            })
            return sums
        },
        handleSizeChange(newSize) {
            this.params.size = newSize
            this.getTableList()
        },
        handleCurrentChange(newPage) {
            this.params.page = newPage
            this.getTableList()
        },
        getCustomColumns() {
            // console.log(this.$refs[this.tag])
            this.$emit("columns", this.customColumn);
        },
        sortChange({ prop, order }) {
            console.log(prop, order)

            let orderStr = ''
            if (order == 'descending') {
                orderStr = 'DESC'
            } else if (order == 'ascending') {
                orderStr = 'ASC'
            }
            let propStr = prop
            if (prop.indexOf('Qty') > -1) propStr = prop.replace('Qty', 'OrderQty')
            this.params.sortField = propStr.split('/')[0]
            this.params.sortBy = orderStr

            if(prop === 'saleDetailSalQtyFormat' || prop === 'backDetailSalQtyFormat'|| prop === 'returnDetailSalQtyFormat' || prop === 'netSalQtyFormat' || prop === 'netInvQtyFormat') {
                this.params.sortField = prop.replace('Format', 'Order')
            }
            if(prop === 'backDetailInvQtyFormat' || prop === 'returnDetailInvQtyFormat' || prop === 'saleDetailInvQtyFormat') {
                this.params.sortField = prop.split('Format')[0]
            }

            if(prop === 'crossProfitMargin') {
                this.params.sortField = 'crossProfitOrderMargin'
            }
            if(prop === 'returnLv') {
                this.params.sortField = 'returnLvOrderQty'
            }

            if(prop === 'returnMeetLv') {
                this.params.sortField = 'returnMeetLvOrderQty'
            }

            if(prop === 'exchangeMeetQty') {
                this.params.sortField = 'exchangeMeetOrderQty'
            }

            this.getTableList()
        },
        exportTableExcel(flag) {
            let obj = { ...this.params }
            delete obj.url
            let exportExcelUrl = '/erpnew/account/c/reada46ceb/sale/collect/queryExcelReport.html'
            let element = this.$refs[this.tag]
            console.log(element)
            let tempArr = element.$children.map(item => ({
                label: item.label,
                prop: item.prop,
                index: item.index
            })).filter(item => item.prop).sort((a, b) => { return a.index - b.index })
            if(flag == 'Y'){
              obj.isSplit = 'Y'
            }
            exportExcelCommonForVue(obj, tempArr, exportExcelUrl)
        },
        jumpDetails(row) {
            this.$emit('onSubmit')
            // 根据算选的 商品   ，筛选右侧选项框的 查询条件
            console.log(row)
            let width = window.top.document.browser.availiframeWidth.value
            let height = window.top.document.browser.availiframeHeight.value
            if(row.billType == 'FX') {
                console.log('访销单详情')
                top.addPanel('访销单详情', `/yunsierp3/index.html#/order/fangxiaoOrder?billNo=${ row.billNo }&billType=${row.billType}`, width, height, true)
            } else {
                top.addPanel('单据详情', `/yunsierp3/index.html#/docket/docketDetails?billType=${ row.billType }&billNo=${ row.billNo }`,width, height, true)
            }
        }
    }
}
</script>
<style type="text/css" src="@/assets/font/pcFont/iconfont.css"></style>
<style scoped lang="less">
.table-content {
    height: calc(100% - 4px);
}

.table {
    height: calc(100% - 32px);

    /deep/.el-table {

        td,
        th {
            padding: 6px 0;
        }
    }

    /deep/ .el-table--scrollable-x .el-table__body-wrapper {
        z-index: 2;
    }
}
</style>